import { farloUiCrmSignup } from './components/footer/farloUiCrmSignup.js';

((document, window, history) => {
	const pushState = history.pushState;

	// Tolerance (px) is the size a viewport can chance
	// before updating css variables this prevents jerky
	// resizing when browser chrome disappears on mobile
	const tolerance = 60;

	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${ vh }px`);
	let lastHeight = window.innerHeight;

	let vw = window.innerWidth * 0.01;
	document.documentElement.style.setProperty('--vw', `${ vw }px`);
	let lastWidth = window.innerWidth;

	let header;

	if (document.querySelector('.site-header')) {
		header = document.querySelector('.site-header').getBoundingClientRect().height;
		document.documentElement.style.setProperty('--navbar-offset', header);
		if (document.querySelector('.pre-header')) {
			header += document.querySelector('.pre-header').getBoundingClientRect().height;
		}
		document.documentElement.style.setProperty('--nav-offset', header);
	}

	const resizeVars = () => {
		if (Math.abs(lastHeight - window.innerHeight) > tolerance) {
			vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${ vh }px`);
			lastHeight = window.innerHeight;
		}

		if (lastWidth != window.innerWidth) {
			vw = window.innerWidth * 0.01;
			document.documentElement.style.setProperty('--vw', `${ vw }px`);
			lastWidth = window.innerWidth;
		}

		if (document.querySelector('.site-header')) {
			header = document.querySelector('.site-header').getBoundingClientRect().height;
			document.documentElement.style.setProperty('--navbar-offset', header);
			if (document.querySelector('.pre-header')) {
				header += document.querySelector('.pre-header').getBoundingClientRect().height;
			}
			document.documentElement.style.setProperty('--nav-offset', header);
		}
	};
	window.addEventListener('resize', () => {
		resizeVars();
	});
	setTimeout(function() {
		resizeVars();
	}, 100);

	// default navicon
	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active'); document.querySelector('.site-navigation').classList.toggle('site-navigation__nav--active');
			document.body.classList.toggle('site-navigation__nav--open');
		});
	}

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		document.documentElement.classList.add(_farlo.browser.init());

		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}
	});

	const youTubeRegex = RegExp(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);

	function farloUiLightbox(elem, div) {
		if (elem.querySelector('.wp-block-image')) {
			elem.querySelector('.wp-block-image').addEventListener('click', function(e) {
				const clonedEmbed = e.currentTarget.closest('.wp-block-group').querySelector('.wp-block-embed').cloneNode(true);
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').appendChild(clonedEmbed);
				div.classList.add('farlo-ui-lightbox--active');
			});
		}

		if (elem.nextElementSibling && elem.nextElementSibling.value) {
			elem.addEventListener('click', function(e) {
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').classList.add('dynamic');
				if (e.target.nextElementSibling && e.target.nextElementSibling.value) {
					div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = e.target.nextElementSibling.value;
				}
				div.classList.add('farlo-ui-lightbox--active');
			});
		}

		if (elem.dataset.video) {
			elem.addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = '<iframe class="farlo-ui-lightbox__inner-content-iframe" src="https://www.youtube-nocookie.com/embed/' + elem.dataset.video.match(youTubeRegex)[ 1 ] + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
				div.classList.add('farlo-ui-lightbox--active');
			});
		}

		if (elem.querySelector('a[href*="youtu.be"]')) {
			elem.querySelector('a[href*="youtu.be"]').addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = '<iframe class="farlo-ui-lightbox__inner-content-iframe" src="https://www.youtube-nocookie.com/embed/' + e.currentTarget.href.match(youTubeRegex)[ 1 ] + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
				div.classList.add('farlo-ui-lightbox--active');
			});
		}

		if (div.querySelector('.farlo-ui-lightbox__button-close')) {
			div.querySelector('.farlo-ui-lightbox__button-close').addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.remove('body--farlo-ui-lightbox-open');
				e.currentTarget.closest('.farlo-ui-lightbox').classList.remove('farlo-ui-lightbox--active');
				if (div.querySelector('.farlo-ui-lightbox__inner-content.dynamic')) {
					div.querySelector('.farlo-ui-lightbox__inner-content').classList.remove('dynamic');
				}
				div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = '';

				if (elem.classList.contains('site-geo-targeting')) {
					window._farlo.storage.set('geotargeted', 'true', 'cookie');
				}
			});
		}
	}

	const lightboxEmbed = document.querySelectorAll('.farlo-ui-lightbox__toggle, [data-video]');
	let div;
	let divInner;
	let divInnerContent;
	let divClose;

	if (lightboxEmbed.length > 0) {
		div = document.createElement('div');
		divInner = document.createElement('div');
		divInnerContent = document.createElement('div');
		divClose = document.createElement('button');
		div.className = 'farlo-ui-lightbox';
		divInner.className = 'farlo-ui-lightbox__inner';
		divInnerContent.className = 'farlo-ui-lightbox__inner-content';
		divClose.className = 'farlo-ui-lightbox__button-close';

		document.body.appendChild(div);
		document.querySelector('.farlo-ui-lightbox').appendChild(divInner);
		document.querySelector('.farlo-ui-lightbox__inner').appendChild(divInnerContent);
		document.querySelector('.farlo-ui-lightbox__inner').appendChild(divClose);

		lightboxEmbed.forEach(function(elem) {
			farloUiLightbox(elem, div);
		});
	}

	function pageScroll(target, offset) {
		const elem = document.querySelector(target);
		if (elem) {
			let scroll = (window.pageYOffset + elem.getBoundingClientRect().top) - window.getComputedStyle(document.documentElement).getPropertyValue('--nav-offset');
			if (typeof offset !== 'undefined') {
				scroll = scroll - offset;
			}
			window.scroll({
				top: scroll,
				behavior: 'smooth'
			});
		}
	}

	if (document.location.hash) {
		const url = document.location.href.split('#');
		const selector = '#' + url[ 1 ];
		try {
			if (document.querySelector(selector)) {
				pageScroll(selector);
			}
		} catch (ex) {

		}
	}

	window.addEventListener('load', () => {
		setTimeout(() => {
			document.querySelector('body').classList.add('loaded');
		}, 100);
	});

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.farlo-ui-crm--inline')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-crm__toggle')) {
			const buttons = document.querySelectorAll('.farlo-ui-crm__toggle');
			const crmBlocks = document.querySelectorAll('.farlo-ui-crm[farlo-ui="crm"]');

			buttons.forEach(function(button) {
				let closestCrmBlock = null;
				let closestDistance = Infinity;

				crmBlocks.forEach(function(block) {
					const distance = button.getBoundingClientRect().top - block.getBoundingClientRect().top;
					if (distance > 0 && distance < closestDistance) {
						closestDistance = distance;
						closestCrmBlock = block;
					}
				});

				if (closestCrmBlock) {
					const crmId = closestCrmBlock.getAttribute('data-crm-id');
					button.setAttribute('data-crm-button-for', crmId);
				}
			});

			buttons.forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiCrmSignup(e);
				});
			});
		}
	});
})(document, window, history);

/* ===== Woo qty stepper (+ auto-update cart) ===== */
(function qtyStepperInit() {
	// run only if a quantity exists on the page
	if (!document.querySelector('.quantity input.qty')) {
		return;
	}

	function findInput(btn) {
		const wrap = btn.closest('.quantity');
		return wrap ? wrap.querySelector('input.qty') : null;
	}

	// +/- clicks (event delegation)
	document.addEventListener('click', function(e) {
		const up = e.target.closest('.site-form-field__input-number-button--up');

		if (up) {
			const input = findInput(up);
			if (!input) {
				return;
			}
			input.stepUp();
			input.dispatchEvent(new Event('change', { bubbles: true }));
		}
		const down = e.target.closest('.site-form-field__input-number-button--down');

		if (down) {
			const input = findInput(down);
			if (!input) {
				return;
			}
			input.stepDown();
			input.dispatchEvent(new Event('change', { bubbles: true }));
		}
	});

	// clamp manual typing + trigger cart refresh when on cart page
	document.addEventListener('change', function(e) {
		const input = e.target;
		if (!input.classList || !input.classList.contains('qty')) {
			return;
		}

		const min = parseFloat(input.min);
		const max = parseFloat(input.max);
		const step = parseFloat(input.step);
		let val = parseFloat(input.value || '0');

		if (!isNaN(min)) {
			val = Math.max(val, min);
		}
		if (!isNaN(max) && max > 0) {
			val = Math.min(val, max);
		}
		if (!isNaN(step) && step > 0) {
			const base = !isNaN(min) ? min : 0;
			val = base + Math.round((val - base) / step) * step;
		}
		if (val !== parseFloat(input.value)) {
			input.value = val;
		}

		// If we're on the cart page, auto-click Update Cart (debounced)
		if (document.querySelector('form.woocommerce-cart-form')) {
			queueCartUpdate();
		}
	});

	let cartUpdateTimer = null;
	function queueCartUpdate() {
		clearTimeout(cartUpdateTimer);
		cartUpdateTimer = setTimeout(function() {
			const btn = document.querySelector('button[name="update_cart"], input[name="update_cart"]');
			if (btn) {
				btn.click();
			}
		}, 400);
	}
}());
